import React from "react";
import { Link } from "react-router-dom";

export default function Error() {
  return (
    <>
      <div className="section-container">
        <section className="not-found-section">
          <h1 className="section-header">404 Nothing to reveal here</h1>
          <Link className="btn top-700" to="/">
            Back to Homepage
          </Link>
        </section>
      </div>
    </>
  );
}
